import React from 'react';
import { C } from './constants';
export function Modal({
  open,
  onClose,
  title,
  children,
  footer,
  maxWidth = 860
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  maxWidth?: number;
}) {
  if (!open) return null;
  return <div onClick={e => {
    if (e.target === e.currentTarget) onClose();
  }} style={{
    position: 'fixed',
    inset: 0,
    zIndex: 100,
    background: 'rgba(26,8,0,0.65)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    backdropFilter: 'blur(3px)'
  }} data-id="element-361">
      <div style={{
      background: '#fff',
      borderRadius: 16,
      width: '100%',
      maxWidth,
      maxHeight: '90vh',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: `0 24px 80px rgba(139,26,26,0.3), 0 0 0 1px rgba(201,168,76,0.3)`
    }} data-id="element-362">
        <div style={{
        background: `linear-gradient(135deg,${C.crimson},#6B0F0F)`,
        color: '#FFF8EC',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
        borderBottom: `3px solid ${C.gold}`
      }} data-id="element-363">
          <h2 style={{
          fontFamily: 'Georgia,serif',
          fontSize: 18,
          fontWeight: 700,
          letterSpacing: '0.5px'
        }} data-id="element-364">
            {title}
          </h2>
          <button onClick={onClose} style={{
          background: 'none',
          border: 'none',
          color: 'rgba(255,240,200,0.8)',
          cursor: 'pointer',
          padding: 6,
          borderRadius: 6,
          display: 'flex'
        }} data-id="element-365">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{
            width: 22,
            height: 22
          }} data-id="element-366">
              <line x1="18" y1="6" x2="6" y2="18" data-id="element-367" />
              <line x1="6" y1="6" x2="18" y2="18" data-id="element-368" />
            </svg>
          </button>
        </div>

        <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: 24,
        background: C.parchment
      }} data-id="element-369">
          {children}
        </div>

        {footer && <div style={{
        borderTop: `2px solid ${C.goldBorder}`,
        padding: '16px 24px',
        background: C.goldPale,
        flexShrink: 0
      }} data-id="element-370">
            {footer}
          </div>}
      </div>
    </div>;
}